import { render } from "./StakeHolderETable.vue?vue&type=template&id=2e64b134"
import script from "./StakeHolderETable.vue?vue&type=script&lang=js"
export * from "./StakeHolderETable.vue?vue&type=script&lang=js"

import "./StakeHolderETable.vue?vue&type=style&index=0&id=2e64b134&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__